import { Refresh } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import { usePage } from 'contexts/Page/Page';
import { useSettings } from 'contexts/Settings/Settings';
import { useMemo } from 'react';
import Badge from '../Badge/Badge';

const hiddenLessons = ['1.1', '1.2.2', '1.2.2.1', '1.2.3', '1.2.3.1'];

export default function WinPercentage() {
    const game = useGame();
    const page = usePage();
    const settings = useSettings();

    const hide = useMemo(() => {
        return !page.lesson || hiddenLessons.includes(page.lesson);
    }, [page.lesson]);

    if (hide) {
        return null;
    }

    return (
        <Box position="relative">
            <Badge
                highlight={game.lessonProps.highlightWinPercentage}
                info="winPercentage"
                label="Win %"
                tabIndex={9}
                type="percentage"
                value={game.round === 'init' ? NaN : game.winProbability}
            />
            {settings.debugEvaluation && (
                <Box position="absolute" right="100%" top={0}>
                    <IconButton onClick={game.updateEvaluation}>
                        <Refresh />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
}
